<div class="label-section">
  <label [for]="forId">
    {{ label }}
  </label>
  @if (!isRequired) {
    <span>Frivillig</span>
  }
  @if (showIsRequiredError) {
    <span class="error-text required-text">*Påkrevd</span>
  }
  @if (labelHelpText) {
    <span class="label-help-text" [ngClass]="{ 'error-text': isErrorState }">
      {{ labelHelpText }}
    </span>
  }
  @if (!!description) {
    <div class="description-text">{{ description }}</div>
  }
</div>
<div class="input-section">
  <textarea
    [attr.data-testid]="testId()"
    [cols]="cols"
    [formControl]="control"
    [id]="forId"
    [ngClass]="{ 'has-error': isErrorState }"
    [placeholder]="placeholder"
    [readOnly]="readonly"
    [rows]="rows"
    [style.resize]="resize"
  ></textarea>
</div>
@if (!!longHelpText) {
  <div class="long-help-text">{{ longHelpText }}</div>
}
@if (isErrorState && !!errorText && !showIsRequiredError) {
  <div class="error-section">
    <mat-icon [svgIcon]="IconNames.ice_warning" />
    <span>{{ errorText }}</span>
  </div>
}
